/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_No_Integrations_TitleInputs */



/**
* | output |
* | --- |
* | "No configurable integrations" |
*
* @param {Rights_Tools_No_Integrations_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_no_integrations_title = /** @type {((inputs?: Rights_Tools_No_Integrations_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_No_Integrations_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine konfigurierbaren Integrationen")
	return /** @type {LocalizedString} */ ("No configurable integrations")
});